import React from 'react'
import { toggleModVisibility, deleteTile } from '../firebase'

const TileDetails = (props) => {
  let module_code, person, day, week, start, end, type, venue, hidden, custom, key, roomId
  module_code = props.details.module_code
  person = props.details.person
  day = props.details.day
  week = props.details.week
  start = props.details.start
  end = props.details.end
  type = props.details.type
  venue = props.details.venue
  hidden = props.details.hidden
  custom = props.details.custom
  key = props.details.key
  roomId = props.room

  if (custom == true) {
    return (
      <div className="TileDetails text-left p-2">
        <h5>{module_code}</h5>
        Time: {start} - {end}
      </div>
    )
  } else {
    return (
      <div className="TileDetails text-left p-2">
        <h5>
          {module_code} <span className="h6">({type})</span>
        </h5>
        Time: {start} - {end}hrs<br />
        Weeks: {week} <br />
        Venue: {venue}
        <hr />
        <button className="btn btn-link text-warning mr-2" onClick={() => toggleModVisibility(roomId, person, key, hidden)}>{hidden ? "Unhide" : "Hide"}</button>
        <button className="btn btn-link text-danger" onClick={() => deleteTile(roomId, person, key)}>Delete</button>
      </div>
    )
  }


}

export default TileDetails